module.exports = __webpack_public_path__ + "img/oufu_35x50x7b.prt.71eb0118.jpg";